import styled from "styled-components";

// styles
import colors from "core/colors";
import { convertPxToRem } from "frontend/components/helpers";

// styled-components
export const AttributionRequiredStyled = styled.div`
    margin-bottom: ${convertPxToRem({ px: 24 })};
    hyphens: auto;
    color: ${colors.secondary.orca};
`;
export const DigitalUseStyled = styled.div`
    margin-bottom: ${convertPxToRem({ px: 24 })};
    color: ${colors.secondary.orca};
`;
